import {
  Component,
  EventEmitter,
  HostBinding,
  Input,
  Output,
} from '@angular/core';
import { MatButtonAppearance, MatButtonModule } from '@angular/material/button';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';

@Component({
  selector: 'app-button',
  imports: [MatButtonModule, MatProgressSpinnerModule],
  templateUrl: './button.html',
  styleUrl: './button.scss',
})
export class Button {
  @HostBinding('class')
  @Input()
  type: MatButtonAppearance = 'text';
  @Input() loading: boolean = false;
  @Output() onClick = new EventEmitter<void>();
  @Input() disabled: boolean = false;
}
